import "./BotonesLoading.css"

export default function BotonesLoading() {
  return <section className="buttonsLoading" />
}
